import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargePermittedActionResponse from "./chargePermittedActionResponse";
import EmailAddressChangePermittedActionResponse from "./emailAddressChangePermittedActionResponse";
import NotificationPreferencesChangePermittedActionResponse from "./notificationPreferencesChangePermittedActionResponse";
import ObtainingPaymentConfirmationPermittedActionResponse from "./obtainingPaymentConfirmationPermittedActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePermittedActionsResponse {
  @observable
  @Type(() => ChargePermittedActionResponse)
  vehicleChangeBeforeValidity!: ChargePermittedActionResponse;

  @observable
  @Type(() => ChargePermittedActionResponse)
  vehicleChangeDuringValidity!: ChargePermittedActionResponse;

  @observable
  @Type(() => ChargePermittedActionResponse)
  validityChange!: ChargePermittedActionResponse;

  @observable
  @Type(() => EmailAddressChangePermittedActionResponse)
  emailAddressChange!: EmailAddressChangePermittedActionResponse;

  @observable
  @Type(() => NotificationPreferencesChangePermittedActionResponse)
  emailNotificationPreferencesChange!: NotificationPreferencesChangePermittedActionResponse;

  @observable
  @Type(() => NotificationPreferencesChangePermittedActionResponse)
  smsNotificationPreferencesChange!: NotificationPreferencesChangePermittedActionResponse;

  @observable
  @Type(() => ObtainingPaymentConfirmationPermittedActionResponse)
  obtainingPaymentConfirmation!: ObtainingPaymentConfirmationPermittedActionResponse;
}
